<template>
  <transition name="fade">
    <div class="image-detail-popup">
      <div class="close-btn" @click="$emit('close')" data-shortcut-esc="imageDetailEditorPopup"><span></span></div>
      <image-detail-editor
        @reflectImage="reflectImage"
        :imageAttr="imageAttr"
      />
    </div>
  </transition>
</template>

<script>
import ImageDetailEditor from '@/components/Util/ImageDetailEditor/ImageDetailEditor'
import ShortCutBase from '@/mixins/ShortCutBase'

export default {
  components: {
    ImageDetailEditor,
  },
  mixins: [
    ShortCutBase,
  ],
  props: [
    'imageAttr',
  ],
  methods: {
    reflectImage (image) {
      this.$emit('reflectImage', image)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/app/_full-screen-modal.scss";
.image-detail-popup {
  @extend .full-screen-modal;
  z-index: 3000;
  background-color: rgba(0, 0, 0, 0.4);
}
</style>
